// Shared between the header (VehicleConfigurationTable) and the rows (VehicleConfigurationItem).
// Both declare their own grid; keeping the template in one place stops them drifting apart.
export const gridTemplateColumns = (hasPieceCount: boolean) =>
  hasPieceCount ? "70px auto 170px 260px" : "70px auto 170px";

export const PIECE_COUNT_TOOLTIP = "This is considered in your Itinerary Planning constraints setup.";

export const PIECE_COUNT_RANGE_ERROR = "The minimum value can't be larger than the maximum value.";
